var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuotationMark = function SvgQuotationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 48",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quotation_mark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16c-.39 0-.77.03-1.15.06C17.74 8.78 22.55 4 28 4V0C12.54 0 0 14.33 0 32c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16Zm40 0c-.39 0-.77.03-1.15.06C57.74 8.78 62.55 4 68 4V0C52.54 0 40 14.33 40 32c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16Z"
  }))));
};
export default SvgQuotationMark;